import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "generated-image-container" }
const _hoisted_3 = { class: "image-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "side-bar" }
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = { class: "prompts" }
const _hoisted_8 = { class: "prompts user-prompt" }
const _hoisted_9 = { class: "footer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "No round played yet", -1)

import BadgeComponent from '@/components/BadgeComponent.vue';
import EndHeader from '@/features/EndHeader.vue';
import EndLayoutComponent from '@/components/EndLayoutComponent.vue';
import { useUserStore } from '@/stores/userStore';
import { computed, ref } from 'vue';
import ProgressComponent from '@/components/ProgressComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameAnalysis',
  setup(__props) {

const userStore = useUserStore();
const activeRound = ref(0);
const activeTry = ref(0);
const rounds = userStore.rounds.filter(
  (singleRound) => singleRound.generatedImages.length > 0
);

const currentRound = computed(
  () => rounds[activeRound.value]?.generatedImages[activeTry.value]
);

const changeRound = (index: number) => {
  activeRound.value = index;
  activeTry.value = 0;
};

const getImageSource = (src: string) => {
  return src.length > 5 ? src : require('@/assets/base_images/placeholder.svg');
};

const changeTry = (index: number) => {
  activeTry.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_unref(rounds) && _unref(rounds).length > 0)
    ? (_openBlock(), _createBlock(EndLayoutComponent, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(EndHeader, {
            title: "Game Analysis",
            class: "header"
          }, {
            default: _withCtx(() => [
              _createVNode(BadgeComponent, { variant: "brand" }, {
                default: _withCtx(() => [
                  _createTextVNode("Level " + _toDisplayString(currentRound.value.level) + " ", 1),
                  _createVNode(BadgeComponent, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(rounds)[activeRound.value].generatedImages?.length) + " Attempt" + _toDisplayString(_unref(rounds)[activeRound.value].generatedImages?.length > 1 ? 's' : ''), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("img", {
            src: _unref(rounds)[activeRound.value].preGeneratedImage.src,
            class: "analysis-image",
            alt: "target-image"
          }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, "Attempt " + _toDisplayString(activeTry.value + 1), 1),
              _createVNode(BadgeComponent, {
                variant: currentRound.value?.survived ? 'success' : 'error',
                withBadge: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(currentRound.value?.score) + " Points", 1)
                ]),
                _: 1
              }, 8, ["variant"])
            ]),
            _createElementVNode("img", {
              src: getImageSource(currentRound.value?.src),
              alt: "generatedImage",
              class: "analysis-image"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rounds)[activeRound.value]?.generatedImages, (genImage, ind) => {
              return (_openBlock(), _createElementBlock("img", {
                key: ind,
                src: getImageSource(genImage?.src),
                class: _normalizeClass({ 'image-preview': true, '--won': genImage?.survived }),
                alt: "preview of generatedImages",
                onClick: ($event: any) => (changeTry(ind))
              }, null, 10, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(rounds)[activeRound.value]?.preGeneratedImage.title), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(currentRound.value?.title), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rounds), (round, index) => {
              return _withDirectives((_openBlock(), _createBlock(ProgressComponent, {
                key: index,
                filled: activeRound.value === index,
                onClick: ($event: any) => (changeRound(index))
              }, null, 8, ["filled", "onClick"])), [
                [_vShow, _unref(rounds).length > 1]
              ])
            }), 128))
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(EndLayoutComponent, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(EndHeader, {
            title: "Game Analysis",
            class: "header"
          }),
          _hoisted_10
        ]),
        _: 1
      }))
}
}

})